import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, SearchIcon, PlusIcon, MessageCircleIcon, MenuIcon } from './IconSet';

const MENU_PREFIXES = [
  '/settings',
  '/security',
  '/favorites',
  '/dashboard',
  '/agent',
  '/admin',
  '/bookings',
  '/reservations',
  '/blog',
  '/help',
  '/safety',
  '/seller-guide',
  '/become-an-agent',
];

const BROWSE_EXTRA_PREFIXES = ['/browse', '/property/', '/seller/'];

function activeTabFor(pathname) {
  if (pathname.startsWith('/messages')) {
    return 'messages';
  }
  if (pathname === '/') {
    return 'home';
  }
  if (pathname.startsWith('/list-property') || pathname.startsWith('/edit-property')) {
    return 'list';
  }
  if (BROWSE_EXTRA_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return 'browse';
  }
  if (MENU_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return 'menu';
  }
  return null;
}

function MobileBottomNav({ onOpenMenu, menuOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const active = menuOpen ? 'menu' : activeTabFor(location.pathname);

  const tabs = [
    { key: 'home', label: 'Home', Icon: HomeIcon, onClick: () => navigate('/') },
    { key: 'browse', label: 'Browse', Icon: SearchIcon, onClick: () => navigate('/browse') },
    { key: 'list', label: 'List', Icon: PlusIcon, onClick: () => navigate('/list-property'), isFab: true },
    { key: 'messages', label: 'Messages', Icon: MessageCircleIcon, onClick: () => navigate('/messages') },
    { key: 'menu', label: 'Menu', Icon: MenuIcon, onClick: onOpenMenu },
  ];

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      {tabs.map(({ key, label, Icon, onClick, isFab }) => (
        <button
          key={key}
          type="button"
          className={`mobile-bottom-nav__item${active === key ? ' mobile-bottom-nav__item--active' : ''}`}
          onClick={onClick}
          aria-current={active === key ? 'page' : undefined}
        >
          {isFab ? (
            <span className="mobile-bottom-nav__fab">
              <Icon size={18} />
            </span>
          ) : (
            <span className="mobile-bottom-nav__icon">
              <Icon size={19} />
            </span>
          )}
          <span className="mobile-bottom-nav__label">{label}</span>
        </button>
      ))}
    </nav>
  );
}

MobileBottomNav.propTypes = {
  onOpenMenu: PropTypes.func.isRequired,
  menuOpen: PropTypes.bool,
};

export default MobileBottomNav;
